// 快速任务
export default {
    taskSettings: 'Task Settings',
    targetPointEdit: 'Target pointEdit',
    target: 'Target',
    performTasks: 'Perform Tasks',
    taskPaused: 'Task Paused',
    taskContinues: 'Task Continues',
    returnImmediately: 'Return Immediately',
    landImmediately: 'Land Immediately',
    pleaseSelectGroup: 'Please select a group',
    pleaseSelectTargetPoint: 'Please select a target point',
    latestTarget: 'Latest Target',
    pleaseEnterNote: 'Please enter a note',
    add: 'Add',
    groupSettings: 'Group Settings',
    groupName: 'Group Name',
    enterUAVname: 'Please enter the UAV name',
    optionalUAV: 'Optional UAV',
    selectedUAV: 'Selected UAV',
    flightParameters: 'Flight Parameters',
    trajectory: 'Trajectory',
    trajectoryOne: 'Trajectory One',
    trajectoryTwo: 'Trajectory Two',
    trajectoryThree: 'Trajectory Three',
    takeoffAltitude: 'Takeoff Altitude',
    maxAltitude: 'Max Altitude',
    speed: 'Speed',
    acceleration: 'Acceleration',
    endAction: 'End Action',
    landing: 'Landing',
    returnFlight: 'Return Flight',
    homing: 'Homing',
    refresh: 'Refresh',
    mapPickup: 'Map Pickup',
    endPickup: 'End Pickup',
    obtain: 'Obtain',
    tip_CBEO: 'cannot be empty or 0',
    tip_PEANV: 'Please enter a numeric value',
    tip_WVR: 'wrong value range',
    tip_TAMB: 'Takeoff altitude must be less than maximum altitude',
    tip_PTODP: 'precision to one decimal place',
    tip_wrongFormat: 'wrong format',
    tip_HCBE: 'height cannot be empty',
    tip_HMBA: 'height must be a numeric value',
}